import React, { useState } from 'react';
import { Plus, Filter, SortDesc } from 'lucide-react';
import { Button } from '../ui/Button';
import { WorkspacesList } from './WorkspacesList';
import { WorkspaceCreationModal } from './WorkspaceCreationModal';
import { WorkspaceDetail } from './WorkspaceDetail';
import { mockWorkspaces } from '../../data/mockData';
export function WorkspacesPage() {
  const [isCreationModalOpen, setIsCreationModalOpen] = useState(false);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState<string | null>(null);
  const selectedWorkspace = selectedWorkspaceId ? mockWorkspaces.find(w => w.id === selectedWorkspaceId) : null;
  return <div className="h-full flex flex-col" data-id="element-223">
      {!selectedWorkspace ? <>
          <div className="flex justify-between items-center mb-6" data-id="element-224">
            <div data-id="element-225">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-226">Workspaces</h1>
              <p className="text-gray-500 mt-1" data-id="element-227">
                Collaborate with your team on insights and take action
              </p>
            </div>
            <Button onClick={() => setIsCreationModalOpen(true)} icon={<Plus size={16} data-id="element-229" />} data-id="element-228">
              New Workspace
            </Button>
          </div>
          <div className="bg-white rounded-lg shadow mb-6" data-id="element-230">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-231">
              <h2 className="text-lg font-medium" data-id="element-232">Your Workspaces</h2>
              <div className="flex space-x-2" data-id="element-233">
                <Button variant="outline" size="sm" icon={<Filter size={16} data-id="element-235" />} data-id="element-234">
                  Filter
                </Button>
                <Button variant="outline" size="sm" icon={<SortDesc size={16} data-id="element-237" />} data-id="element-236">
                  Sort
                </Button>
              </div>
            </div>
            <WorkspacesList workspaces={mockWorkspaces} onSelect={id => setSelectedWorkspaceId(id)} data-id="element-238" />
          </div>
        </> : <WorkspaceDetail workspace={selectedWorkspace} onBack={() => setSelectedWorkspaceId(null)} data-id="element-239" />}
      {isCreationModalOpen && <WorkspaceCreationModal onClose={() => setIsCreationModalOpen(false)} onCreateWorkspace={workspace => {
      setIsCreationModalOpen(false);
      // In a real app, we would add the workspace to the list
      // For now, we'll just show a detail view with the mock data
      setSelectedWorkspaceId(mockWorkspaces[0].id);
    }} data-id="element-240" />}
    </div>;
}